import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useContext, useMemo, useState, Fragment, useRef, useEffect } from 'react';
import classNames from 'classnames';
import Tooltip from '../../../utils/Tooltip';
import Icon from '../../../general/Icon';
import EmojiMenu from './EmojiMenu';
import { RichTextContext } from '..';
var ToolbarItem = function ToolbarItem(_ref) {
  var classNameProp = _ref.className,
    classNameActive = _ref.classNameActive,
    color = _ref.color,
    item = _ref.item,
    hint = _ref.hint,
    active = _ref.active;
  var _useContext = useContext(RichTextContext),
    editor = _useContext.editor,
    setShowingMenuPopover = _useContext.setShowingMenuPopover;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    popoverVisible = _useState4[0],
    setPopoverVisible = _useState4[1];
  var className = classNames(classNameProp, _defineProperty({}, classNameActive, active));
  var emojiMenuRef = useRef(null);
  useEffect(function () {
    if (item === 'emoji' && popoverVisible) {
      var handleKeyDown = function handleKeyDown(event) {
        var _emojiMenuRef$current;
        emojiMenuRef === null || emojiMenuRef === void 0 || (_emojiMenuRef$current = emojiMenuRef.current) === null || _emojiMenuRef$current === void 0 ? void 0 : _emojiMenuRef$current.onKeyDown(event);
      };
      document.addEventListener('keydown', handleKeyDown, true);
      return function () {
        document.removeEventListener('keydown', handleKeyDown, true);
      };
    }
  }, [item, popoverVisible]);
  var _ref2 = /*#__PURE__*/React.createElement(Fragment, null, hint);
  var tooltipProps = useMemo(function () {
    return {
      placement: 'top',
      content: _ref2,
      mouseEnterDelay: 0.2
    };
  }, [hint]);
  var iconProps = useMemo(function () {
    var name, onClick;
    var commonProps = {
      color: color,
      className: className
    };
    switch (item) {
      case 'b':
        name = 'bold';
        onClick = function onClick() {
          return editor.chain().focus().toggleBold().run();
        };
        break;
      case 'i':
        name = 'italic';
        onClick = function onClick() {
          return editor.chain().focus().toggleItalic().run();
        };
        break;
      case 'u':
        name = 'underline';
        onClick = function onClick() {
          return editor.chain().focus().toggleUnderline().run();
        };
        break;
      case 'del':
        name = 'strikethrough';
        onClick = function onClick() {
          return editor.chain().focus().toggleStrike().run();
        };
        break;
      case 'ol':
        name = 'orderedList';
        onClick = function onClick() {
          return editor.chain().focus().toggleOrderedList().run();
        };
        break;
      case 'ul':
        name = 'unorderedList';
        onClick = function onClick() {
          return editor.chain().focus().toggleBulletList().run();
        };
        break;
      case 'mention':
        name = 'mention';
        onClick = function onClick() {
          return editor.chain().focus().insertContent('@').run();
        };
        break;
      case 'emoji':
        name = 'mood';
        break;
      default:
        break;
    }
    return _objectSpread({
      name: name,
      onClick: onClick
    }, commonProps);
  }, [color, item, editor, className]);
  var handlePopoverVisibility = useCallback(function (visible) {
    setPopoverVisible(visible);
    setShowingMenuPopover && setShowingMenuPopover(visible);
  }, [setShowingMenuPopover]);
  switch (true) {
    case !editor:
      return null;
    case item === 'emoji':
      return /*#__PURE__*/React.createElement(EmojiMenu, {
        popoverVisible: popoverVisible,
        onVisibleChange: handlePopoverVisibility,
        ref: emojiMenuRef
      }, /*#__PURE__*/React.createElement(Tooltip, _extends({
        visible: !popoverVisible && visible
      }, tooltipProps), /*#__PURE__*/React.createElement("span", {
        className: className,
        onMouseEnter: function onMouseEnter() {
          return setVisible(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setVisible(false);
        }
      }, /*#__PURE__*/React.createElement(Icon, iconProps))));
    default:
      return /*#__PURE__*/React.createElement(Tooltip, tooltipProps, /*#__PURE__*/React.createElement("span", {
        className: className
      }, /*#__PURE__*/React.createElement(Icon, iconProps)));
  }
};
export default ToolbarItem;